import {
	MDBTabs,
	MDBTabsContent,
	MDBTabsItem,
	MDBTabsLink,
	MDBTabsPane,
} from "mdb-react-ui-kit";
import React, { useState } from "react";
import FormNft from "../FormNft";
import FormPostAdd from "../FormPostAdd";

function FormPostParent({ profilePicture, isModal, onClose }) {
	const [tabActive, setTabActive] = useState("tab1");
	const handleClick = (tab) => {
		if (tab === tabActive) return;
		setTabActive(tab);
	};
	return (
		<>
			<MDBTabs fill className='mb-3'>
				<MDBTabsItem>
					<MDBTabsLink
						onClick={() => handleClick("tab1")}
						active={tabActive === "tab1"}
					>
						Post
					</MDBTabsLink>
				</MDBTabsItem>
				<MDBTabsItem>
					<MDBTabsLink
						onClick={() => handleClick("tab2")}
						active={tabActive === "tab2"}
					>
						NFT
					</MDBTabsLink>
				</MDBTabsItem>
			</MDBTabs>

			<MDBTabsContent>
				<MDBTabsPane show={tabActive === "tab1"}>
					<FormPostAdd
						isModal={isModal}
						onClose={onClose ? onClose : ""}
						profilePicture={profilePicture}
					/>
				</MDBTabsPane>
				<MDBTabsPane show={tabActive === "tab2"}>
					<FormNft profilePicture={profilePicture} />
				</MDBTabsPane>
			</MDBTabsContent>
		</>
	);
}

export default FormPostParent;
